module.exports = __webpack_public_path__ + "static/media/DSC_LH.8b5673f9.png";